export const API_URL = process.env.REACT_APP_API_URL || "https://api.citymoshi.com";
export const LOCAL_URL = process.env.REACT_APP_API_URL || "http://localhost:3333";

export const APP_STORE_LINK = "https://apps.apple.com/us/app/citymoshi/id6560116116";
export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.citymoshi.app";
